// NotFoundPage — catch-all `*` route with a localized home button.
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ErrorState } from '../ui/index.js';

export function NotFoundPage() {
  const { t } = useTranslation(['shell', 'common']);
  const navigate = useNavigate();
  return (
    <ErrorState
      title={t('notFound.title')}
      text={t('notFound.text')}
      onRetry={() => navigate('/')}
      retryLabel={t('common:actions.goHome')}
    />
  );
}
